import { render, staticRenderFns } from "./Request.vue?vue&type=template&id=a936f3b2&scoped=true"
import script from "./Request.vue?vue&type=script&lang=js"
export * from "./Request.vue?vue&type=script&lang=js"
import style0 from "./Request.vue?vue&type=style&index=0&id=a936f3b2&prod&lang=scss&scoped=true"
import style1 from "./Request.vue?vue&type=style&index=1&id=a936f3b2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a936f3b2",
  null
  
)

export default component.exports